import { Component, EventEmitter, Inject, Input, OnInit, Output, SimpleChanges, OnChanges } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatButton } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'


import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog'
import { DocumentTypeService } from '../../../core/services/document/document-type/document-type.service'
import { MatIconModule } from '@angular/material/icon'
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { MatTableModule } from '@angular/material/table'
import { provideNgxMask } from 'ngx-mask'
import { ContractItemService } from '../../../core/services/contract/contract-item/contract-item.service'
import { ItinerariesService } from '../../../core/services/itineraries/itineraries/itiniraries.service'
import { ItineraryModalComponent } from './itinerary-modal/itinerary-modal.component'
import { ItineraryEditComponent } from './itinerary-edit/itinerary-edit.component'

import { MatCardModule } from '@angular/material/card';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { ServiceItinerarieOrderService } from '../../../core/services/service/service-order-itineraries/service-order.service'
import { ServiceOrderService } from '../../../core/services/service/service-order/service-order.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'


@Component({
  selector: 'itinerary-service-order',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButton,
    MatSelectModule,
    MatIconModule,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatCardModule,
    DragDropModule,
    MatProgressBar



  ],
  templateUrl: './itinerary.component.html',
  styleUrl: './itinerary.component.scss',
  providers: [
    DocumentTypeService,
    ViaCepService,
    provideNgxMask({
      dropSpecialCharacters: false
    }),
  ],
  standalone: true,
})
export class ItineraryComponent implements OnInit, OnChanges {
  @Output() valid = new EventEmitter<boolean>();

  constructor(

    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private documentTypeService: DocumentTypeService,
    private addressTypeService: AddressTypeService,
    private viaCepService: ViaCepService,
    private contractItemService: ContractItemService,
    private itinerariesService: ItinerariesService,
    private ordemService: ServiceOrderService,
    private snackbar: SnackbarCustomService,
    private serviceItinerarieOrderService: ServiceItinerarieOrderService
  ) { }



  form!: FormGroup;
  itemsList: any[] = [];
  @Output() response = new EventEmitter<any>()
  @Input() editItem: any = {}
  @Input() idItemContract = -1
  @Input() idItemPropose = -1
  @Input() itemOs: any
  listType: any[] = []
  documentTypeList: any[] = []
  itineraryList: any[] = []
  loading = false
  buttonDisable = false
  idItemProposta: any = -1



  editIndex: number | null = null;
  editAgendaItem: any = null;
  page = 1
  rows = 10
  numberRows = 0
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  cepMask = '00000-000';


  columns: any[] = [
    { keyColumn: 'localParada', key: 'localParada', description: 'Local' },
    { keyColumn: 'cep', key: 'cep', description: 'Cep' },
    { keyColumn: 'logradouro', key: 'logradouro', description: 'Logradouro' },
    { keyColumn: 'numero', key: 'numero', description: 'Número' },
    { keyColumn: 'bairro', key: 'bairro', description: 'Bairro' },
    { keyColumn: 'cidade', key: 'cidade', description: 'Cidade' },
    { keyColumn: 'areaTarifario', key: 'areaTarifario', description: 'Área Tarifario' },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ];

  displayedColumns = this.columns.map((col) => col.keyColumn);


  ngOnInit(): void {
    this.listTypeAddress()
    this.createForm()
    this.listPagedItinerary()

    // if (this.data && this.data.contratoItemId) {
    //   this.idItemContract = this.data.contratoItemId;
    // }

    // this.searchItinerary()
    // if (this.data?.contratoItemId) {
    //   this.idItemContract = this.data.contratoItemId;
    //   this.contractItemService.getContractItembyId(this.idItemContract).subscribe({
    //     next: (res) => {
    //       this.idItemPropose = res.data.itemPropostaId;
    //       this.listPagedItinerary(); // chame aqui com base no idItemPropose
    //     },
    //     error: (err) => console.error('Erro ao buscar contrato item:', err)
    //   });
    // }



  }

  drop(event: CdkDragDrop<any[]>) {
    // Encontre todos os índices das paradas na lista total
    const paradaIndexes = this.itemsList
      .map((item, idx) => item.trecho === 'P' ? idx : -1)
      .filter(idx => idx !== -1);

    // Descubra qual parada foi arrastada
    const prevParadaIndex = paradaIndexes.findIndex(idx => idx === event.previousIndex);
    const currParadaIndex = paradaIndexes.findIndex(idx => idx === event.currentIndex);

    // Se ambos são válidos, mova a parada na lista total
    if (prevParadaIndex !== -1 && currParadaIndex !== -1) {
      // Pegue todas as paradas
      const paradas = this.itemsList.filter(item => item.trecho === 'P');
      // Reordene as paradas
      moveItemInArray(paradas, prevParadaIndex, currParadaIndex);

      // Reconstrua a lista mantendo origem e destino fixos
      const novaLista = [];
      for (let i = 0; i < this.itemsList.length; i++) {
        if (this.itemsList[i].trecho === 'P') {
          // Pegue a próxima parada reordenada
          novaLista.push(paradas.shift());
        } else {
          // Mantenha origem/destino na mesma posição
          novaLista.push(this.itemsList[i]);
        }
      }
      this.itemsList = novaLista;
      this.editPositonList();
    }
  }
  getItemProposeId(): void {
    this.loading = true;
    this.contractItemService.getContractItembyId(this.idItemContract).subscribe({
      next: (res) => {
        this.idItemPropose = res.data.itemPropostaId;
        this.listItineraries();
      },
      error: (err) => {
        console.error('Erro ao obter itemPropostaId', err);
        this.loading = false;
      }
    });
  }




  receptItemPropostaId(id: number) {
    this.idItemProposta = id;
    // agora você pode usar como quiser!
  }


  listItineraries(): void {
    this.itinerariesService.listPagedItinerariesByItemPropose(this.idItemPropose, this.rows)
      .subscribe({
        next: (res) => {
          this.itemsList = res.data || [];
          this.numberRows = this.itemsList.length;
          this.loading = false;
        },
        error: (err) => {
          console.error('Erro ao listar itinerários', err);
          this.itemsList = [];
          this.loading = false;
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }
  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  handleTableResponse(event: any) {
    this.itemsList = event;
  }

  listTypeAddress() {
    this.addressTypeService.listAddressType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => { },
    })
  }

  editPositonList() {
    // Separe os itens
    const destino = this.itemsList.find(item => item.trecho === 'D');
    const origem = this.itemsList.find(item => item.trecho === 'O');
    const paradas = this.itemsList.filter(item => item.trecho === 'P');

    // Monta o array de ordenação
    const ordenacaoObj: any[] = [];

    // if (origem) {
    //   ordenacaoObj.push({
    //     id: origem.id,
    //     ordenacao: 1
    //   });
    // }

    // Paradas: ordenação de 2 até N
    paradas.forEach((item, idx) => {
      ordenacaoObj.push({
        id: item.id,
        ordenacao: idx + 2
      });
    });

    // // Origem: maior valor (depois das paradas)
    // if (destino) {
    //   ordenacaoObj.push({
    //     id: destino.id,
    //     ordenacao: paradas.length + 2
    //   });
    // }

    const body = {
      ordenacaoObj,
      codigoOs: this.data.idOs
    };

    this.serviceItinerarieOrderService.editPositionItemListOrdemService(body).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message);
        this.listPagedItinerary();
      }
    });
  }

  getAddressByPostalCode(): void {
    const postalCode = this.form.get('postalCode')?.value;
    if (postalCode && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (res) => this.fillFormViaCep(res),
        error: (err) => console.error('Erro ao buscar endereço', err)
      });
    }
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('addressType')?.setValue(this.editItem.tipo_endereco_id)
    this.form.get('postalCode')?.setValue(this.editItem.cep)
    this.form.get('street')?.setValue(this.editItem.logradouro)
    this.form.get('number')?.setValue(this.editItem.numero)
    this.form.get('neighborhood')?.setValue(this.editItem.bairro)
    this.form.get('city')?.setValue(this.editItem.cidade)
    this.form.get('country')?.setValue(this.editItem.pais)
    this.form.get('state')?.setValue(this.editItem.estado)
    this.form.get('latitude')?.setValue(this.editItem.latitude)
    this.form.get('longitude')?.setValue(this.editItem.longitude)
  }

  fillFormViaCep(element: any) {
    if (element.erro) {
      this.form.get('street')?.setValue('')
      this.form.get('number')?.setValue('')
      this.form.get('neighborhood')?.setValue('')
      this.form.get('city')?.setValue('')
      this.form.get('state')?.setValue('')
      this.form.get('country')?.setValue('')
    } else {
      this.form.get('street')?.setValue(element.logradouro)
      this.form.get('number')?.setValue('')
      this.form.get('neighborhood')?.setValue(element.bairro)
      this.form.get('city')?.setValue(element.localidade)
      this.form.get('state')?.setValue(element.estado)
      this.form.get('country')?.setValue('Brasil')
    }
  }

  resetForm() {
    this.form.reset()
  }

  getDocumentTypes() {
    this.documentTypeService.listDocumentType().subscribe({
      next: (res) => {
        this.documentTypeList = res.data; // Use the correct property that contains the array
      },
      error: (err) => {
        // trate o erro se necessário
        this.documentTypeList = [];
      }
    });
  }

  // organizeItineraryList() {
  //   const origem = this.itemsList.find(item => item.trecho === 'D');
  //   const destino = this.itemsList.find(item => item.trecho === 'O');
  //   const paradas = this.itemsList.filter(item => item.trecho === 'P');

  //   const novaLista = [];
  //   if (origem) novaLista.push(origem);
  //   novaLista.push(...paradas);
  //   if (destino) novaLista.push(destino);

  //   this.itemsList = novaLista;
  // }

  listPagedItinerary() {
    this.loading = true;
    this.ordemService.listPagedServiceOrderOrdenation(this.page, this.rows, this.data.idOs,)
      .subscribe({
        next: (res) => {
          this.itemsList = res.data ?? [];
          this.numberRows = this.itemsList.length
          this.loading = false;

          // this.organizeItineraryList();
          // this.editPositonList();

          if (this.numberRows >= 2) {

            this.valid.emit(true)

          } else {

            this.valid.emit(false)


          }


        },
        error: (err) => {
          this.itemsList = [];
          this.numberRows = 0;
          this.loading = false;
          console.error("Erro ao buscar itinerários:", err);
        }
      });
  }


  searchItinerary() {
    this.loading = true;
    this.serviceItinerarieOrderService.searchPagedItinerarieServiceOrderbyId(this.data.codigoOs)
      .subscribe({
        next: (res) => {
          this.idItemPropose = res.data.itemPropostaId;
          this.itinerariesService.listPagedItinerariesByItemPropose(this.idItemPropose, this.rows)
            .subscribe({
              next: (res) => {
                this.treatResponse(res)
              },
              error: (err) => {
                this.loading = false;
                this.itineraryList = []
              }
            })
        },
        error: (err) => {
        }

      })
  }


  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }



  createForm(): void {
    this.form = this.formBuilder.group({
      local: ['', Validators.required],
      postalCode: ['', Validators.required],
      street: [''],
      state: [''],
      number: [''],
      neighborhood: [''],
      city: [''],
      country: ['Brasil'],
      latitude: [''],
      longitude: [''],
    })
  }

  getAddressTypeDescription() {
    const addressTypeId = this.form.get('addressType')?.value
    if (addressTypeId) {
      const element = this.listType.find((ele: any) => {
        return ele.id === addressTypeId
      })
      return element.descricao
    } else {
      return ''
    }
  }

  createAddress() {

    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    const item = this.form.value;
    this.response.emit(item);
    this.form.reset();
  }

  startEdit(item: any) {
    const idOs = this.data.idOs;

    const dialogRef = this.dialog.open(ItineraryEditComponent, {
      id: 'itinerary-service-order-edit',
      data: {
        idOs,
        item: item
      },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '850px',
      width: '100%',
      maxHeight: '500px',
      height: '100%',
    });

    // Captura o retorno quando o modal é fechado
    dialogRef.afterClosed().subscribe(result => {
      if (result?.success) {
        // Atualiza a lista de itinerários
        this.listPagedItinerary();

      } else if (result && !result.success) {
        console.error('Erro ao atualizar itinerário:', result.error);
      }
    });
  }


  editAddress() {
    if (this.editIndex === null || this.editIndex === undefined) return;
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    const item = {
      local: this.form.value.local,
      cep: this.form.value.postalCode,
      logradouro: this.form.value.street,
      numero: this.form.value.number,
      bairro: this.form.value.neighborhood,
      cidade: this.form.value.city,
      estado: this.form.value.state,
      pais: this.form.value.country,
      latitude: this.form.value.latitude,
      longitude: this.form.value.longitude,
      address: `${this.form.value.neighborhood}, ${this.form.value.number} , ${this.form.value.city} - ${this.form.value.state}`,
    };
    this.itemsList[this.editIndex] = item;
    this.itemsList = [...this.itemsList];
    this.editIndex = null;
    this.form.reset();
  }

  deleteAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  cancel() {
    this.editIndex = null
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }

  createModel(edit = false) {
    if (edit) {
      return {


        local: this.form.controls['local'].value ?? '',
        tipo_endereco: this.getAddressTypeDescription(),
        cep: this.form.controls['postalCode'].value ?? '',
        logradouro: this.form.controls['street'].value ?? '',
        numero: this.form.controls['number'].value ?? '',
        bairro: this.form.controls['neighborhood'].value ?? '',
        estado: this.form.controls['state'].value ?? '',
        cidade: this.form.controls['city'].value ?? '',
        pais: this.form.controls['country'].value ?? '',
        latitude: this.form.controls['latitude'].value ?? '',
        longitude: this.form.controls['longitude'].value ?? '',
      }
    } else {
      return {


        local: this.form.controls['local'].value ?? '',
        cep: this.form.controls['postalCode'].value ?? '',
        logradouro: this.form.controls['street'].value ?? '',
        numero: this.form.controls['number'].value ?? '',
        bairro: this.form.controls['neighborhood'].value ?? '',
        estado: this.form.controls['state'].value ?? '',
        cidade: this.form.controls['city'].value ?? '',
        pais: this.form.controls['country'].value ?? '',
        latitude: this.form.controls['latitude'].value ?? '',
        longitude: this.form.controls['longitude'].value ?? '',
      }
    }
  }


  addItemToList() {
    const idOs = this.data.idOs
    const idItemProposta = this.idItemPropose
    const dialogRef = this.dialog.open(ItineraryModalComponent, {
      id: 'itinerary-service-order-modal',
      data: { idOs, idItemProposta },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '850px',
      width: '100%',
      maxHeight: '400px',
      height: '100%',

    })
    dialogRef.afterClosed().subscribe(result => {
      if (result?.success) {
        // Atualiza a lista de itinerários
        this.listPagedItinerary();

        // Opcional: Mostra mensagem de sucesso
      } else if (result && !result.success) {
        console.error('Erro ao atualizar itinerário:', result.error);
      }
    });
  }




  deleteItem(item: any) {
    this.itemsList = this.itemsList.filter(i => i.id !== item.id)
    this.loading = true;
    this.ordemService.removeServiceOrderItinerary(item.id).subscribe({
      next: (res) => {
        this.loading = false;
        this.snackbar.success(res.message)
      },
      error: (err) => {
        this.snackbar.error(err.message)
      },
      // completion: () => {
      //   this.loading = false
      // }

    })
  }

  goToStep(index: number) {
    // Se você quiser implementar navegação para um passo específico
    // Pode ser usado para expandir detalhes ou navegar para outra view
    // Exemplo: this.stepper.selectedIndex = index;
  }



}
